<template lang="pug">
div
    v-text-field(
        ref="input"
        v-bind="$attrs"
        @keydown="controlSelector($event)"
        v-model="search"
        @keyup.enter="select()"
        
    )
    .list-container(ref="container")
        v-list.pa-2
            template(
                v-for="(item, idx) in filteredItems"
            )
                v-list-tile.selector-tile(
                    :class="{'active-tile': idx === activeIndex}"
                    :key="idx"
                    @click="handleClick(idx)"
                    :ref="`itm${idx}`"
                ) 
                    v-layout
                        v-flex.xs10
                            span {{item.text}}
                        v-flex.xs2
                            slot(name="tail" :item="item")
                v-divider
</template>

<script>
// -- Component Imports --
// -- JS Data files import --
// -- JS Libraries Import --
// -- Mixins imports --
// -- Vuex Imports --
// -- Other Imports --
export default {
    name: 'component-name',
    inheritAttrs: false,
    props: {
        // ------------------------- UI State ---------------------------------
        // ------------------------- Component Data ---------------------------
        /**
         * @description
         */
        value: {
            type: Number,
            default: () => 0,
        },
        mobile: {
            type: Boolean,
            default: false,
        },
        /**
         * @description
         */
        items: {
            type: Array,
            default: () => [],
        },
    },
    data: function() {
        return {
            // ------------------------ UI State ------------------------------
            // ------------------------ Data storing --------------------------
            search: '',
            filteredItems: [],
            activeIndex: 0,
        }
    },
    computed: {
        // -------------------- Editable props binding-------------------------
        // -------------------- Alias settings --------------------------------
        // -------------------- Dynamic UI State ------------------------------
        // -------------------- Displayed data --------------------------------
        // -------------------- Methods data ----------------------------------
        // -------------------- Vuex mappings ---------------------------------
    },
    methods: {
        // -------------------- UI Modification -------------------------------
        incrementIndex() {
            if (this.activeIndex < this.filteredItems.length - 1)
                this.activeIndex++
        },
        decrementIndex() {
            if (this.activeIndex > 0) this.activeIndex--
        },
        // -------------------- Data fetching ---------------------------------
        // -------------------- Data handling and transformations -------------
        select() {
            this.$emit('input', this.filteredItems[this.activeIndex])
            this.$emit('change')
        },
        filter() {
            if (!this.search) {
                this.filteredItems = this.items
            } else {
                this.filteredItems = this.items.filter(({ text }) => {
                    let search = this.search.toUpperCase()
                    let re = new RegExp(search, 'g')
                    let result = text.match(re)
                    if (result) {
                        return true
                    } else {
                        return false
                    }
                })
            }
        },
        // -------------------- Validations and Error handling ----------------
        // -------------------- Other functions -------------------------------
        focus() {
            this.$nextTick(() => this.$refs.input.focus())
        },
        controlSelector(e) {
            let prevent = event => {
                event.preventDefault()
                event.stopPropagation()
            }
            switch (e.keyCode) {
                // ESC
                // case 27:
                //     this.$emit('keydown', e)
                //     break
                // Arrow UP
                case 38:
                    prevent(e)
                    this.decrementIndex()
                    this.autoScroll()
                    break
                // Arrow Down
                case 40:
                    prevent(e)
                    this.incrementIndex()
                    this.autoScroll()
                    break
                default:
                    break
            }
            this.$emit('keydown', e)
        },
        handleClick(idx) {
            this.activeIndex = idx
            //this.$emit('item:click', idx)
            this.select()
        },
        autoScroll() {
            const containerHeight = this.$refs.container.offsetHeight
            const containerOffsetTop = this.$refs.container.scrollTop
            const activeOffset = this.$refs[`itm${this.activeIndex}`][0].$el
                .offsetTop
            const containerOffset = containerOffsetTop + containerHeight
            if (activeOffset >= containerOffset) {
                this.$refs.container.scrollTop += 52
            } else {
                this.$refs.container.scrollTop -= 52
            }
        },
        // -------------------- Vuex mappings ---------------------------------
    },
    watch: {
        /**
         * @description
         */
        items: {
            handler() {
                this.filteredItems = this.items
            },
            immediate: true,
        },
        search() {
            this.filter()
        },
    },
    // components: {},
    // mixins: [],
    // filters: {},
    // ------------------------ Lifecycle Methods -----------------------------
    // ------------------------ End Lifecycle Methods -------------------------
}
</script>

<style lang="scss" scoped>
.list-container {
    height: calc(100vh - 300px);
    overflow-y: scroll;
}
.selector-tile {
    border: 2px solid;
    border-color: white;
    overflow: hidden;
    &.active-tile {
        border-color: blue !important;
    }
}
</style>
